import { render, staticRenderFns } from "./CellRendererEditGroup.vue?vue&type=template&id=23c78da1&"
import script from "./CellRendererEditGroup.vue?vue&type=script&lang=js&"
export * from "./CellRendererEditGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports